/* Viretta collection.v2 (sections/v2-collection.liquid): »Vis alle« reveals the rest of the page, sort changes the URL,
   the filter drawer (moved to <body> above the theme header), and »Læs mere« in the SEO text. */
(() => {
  if (window.VirettaV2Collection) return;
  window.VirettaV2Collection = true;

  const init = (root) => {
    if (root.v2col) return;
    root.v2col = true;

    // Mobile: bring the current category tile into view in the swipe row
    const on = root.querySelector('.v2-col__tile.is-on');
    const row = root.querySelector('.v2-col__tiles');
    if (on && row && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, on.offsetLeft - 20 - row.offsetLeft);

    const grid = root.querySelector('[data-v2-grid]');
    const more = root.querySelector('[data-v2-more]');
    const showAll = root.querySelector('[data-v2-showall]');
    if (showAll && grid) {
      showAll.addEventListener('click', () => {
        grid.classList.add('is-all');
        if (more) more.hidden = true;
        const pages = root.querySelector('[data-v2-pages]');
        if (pages) pages.hidden = false;
      });
    }

    // Products per row, like LIVE's collection-top-bar sliders (desktop 3–5 from 1000 px, mobile 1–2)
    const size = root.querySelectorAll('[data-v2-cols]');
    if (size.length) {
      const html = document.documentElement;
      const key = (k) => `v2-cols-${k}`;
      const set = (k, v) => { html.style.setProperty(`--${key(k)}`, v); html.setAttribute(`data-${key(k)}`, v); };
      size.forEach((r) => {
        const k = r.dataset.v2Cols;
        let v = null;
        try { v = sessionStorage.getItem(key(k)); } catch (e) { /* no storage */ }
        if (v) { r.value = v; set(k, v); } else if (k === 'd' && window.matchMedia('(max-width: 1199px)').matches) r.value = 3;
        r.addEventListener('input', () => {
          set(k, r.value);
          size.forEach((o) => { if (o !== r && o.dataset.v2Cols === k) o.value = r.value; });
          try { sessionStorage.setItem(key(k), r.value); } catch (e) { /* no storage */ }
        });
      });
    }

    const sort = root.querySelector('[data-v2-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    const drawer = root.querySelector('[data-v2-filter]');
    if (drawer) {
      const wrap = document.createElement('div');
      wrap.className = root.className.replace(/\bv2-col\b/, 'v2-portal');
      wrap.appendChild(drawer);
      document.body.appendChild(wrap);
      const open = root.querySelector('[data-v2-filter-open]');
      const close = () => { drawer.hidden = true; document.documentElement.style.overflow = ''; if (open) open.setAttribute('aria-expanded', 'false'); };
      if (open) open.addEventListener('click', () => { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; open.setAttribute('aria-expanded', 'true'); });
      drawer.addEventListener('click', (e) => { if (e.target.closest('[data-v2-filter-close]')) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
      // Empty price fields are not sent (Shopify would read them as 0)
      const form = drawer.querySelector('form');
      if (form) form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
      });
    }

    const seoBtn = root.querySelector('[data-v2-seotoggle]');
    if (seoBtn) {
      seoBtn.addEventListener('click', () => {
        const m = root.querySelector('[data-v2-seomore]');
        const openNow = m.hidden;
        m.hidden = !openNow;
        seoBtn.textContent = openNow ? 'Vis mindre' : 'Læs mere';
        seoBtn.setAttribute('aria-expanded', String(openNow));
      });
    }
  };

  // Card badges stay on one line: from the last badge backwards, hide what does not fit (the first badge has priority)
  const fitBadges = () => {
    document.querySelectorAll('.v2-card__bdg').forEach((box) => {
      const b = [...box.children];
      b.forEach((x) => x.classList.remove('is-off'));
      for (let i = b.length - 1; i > 0 && box.scrollWidth > box.clientWidth + 1; i--) b[i].classList.add('is-off');
    });
  };
  let fitT;
  const refit = () => { clearTimeout(fitT); fitT = setTimeout(fitBadges, 80); };
  window.addEventListener('resize', refit);
  document.addEventListener('input', (e) => { if (e.target.matches('[data-v2-cols]')) refit(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);

  const run = () => { document.querySelectorAll('[data-v2-collection]').forEach(init); fitBadges(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
